
















































































































































import { Component, ProvideReactive, mixins } from 'nuxt-property-decorator'
import { mapState, mapGetters } from 'vuex'
import {
  getLotAditionalPhotos,
  getProject,
  getModels,
  getConsumerMapHomes,
  getConsumerMapHomesites,
  getParcelIdsByType,
} from '~/api/consumer_map.api'
import { getConsumerMapProperty } from '~/api/sales_map.api'
import Lot from '~/models/lot'
import {
  Amenity,
  AmenityResponse,
  CategoryResponse,
  LegacyAmenity,
  LotInfo,
} from '~/models'
import PagedResponse from '~/models/pagedResponse'
import { PublicProject } from '~/models/project'
import { setScrollOnBottomEvent, removeScrollListener } from '~/utils/scroll'
import Card from '~/components/consumer_map/Card.vue'
import InfoCard from '~/components/consumer_map/InfoCard.vue'
import SideModalV3 from '~/components/consumer_map_v3/SideModalV3.vue'
import Map from '~/components/consumer_map/Map.vue'
import NotFound from '~/components/consumer_map/NotFound.vue'
import MapFilter from '~/components/consumer_map/map_filters.vue'
import debounce from '~/utils/debounce'
import MobileCard from '~/components/consumer_map/MobileCard.vue'
import MobileCardAmenity from '~/components/consumer_map/MobileCardAmenity.vue'
import projectConfig from '~/assets/project-config.json'
import globalStyling from '~/mixins/globalStyling'
import {
  getAllAmenities,
  getLegacyXOAmenities,
  getPoiCategories,
} from '~/api/amenity.api'
import MapPropertiesList from '~/components/consumer_map_v3/MapPropertiesList.vue'
import MapPropertiesPrintList from '~/components/consumer_map_v3/MapPropertiesPrintList.vue'
import { consumerMapStore, projectStore, uiStore } from '~/store'
import { MapSidebarTabs } from '~/enums/map'
import { LotTypes } from '~/enums/lots'

const KNOWN_PARAMS = [
  'builder',
  'style',
  'beds',
  'price_min',
  'price_max',
  'baths',
  'stories',
  'garages',
  'neighborhood',
  'sqft_min',
  'sqft_max',
  'move_in_date',
  'property_type',
  'condo_at',
  'sort',
  'acreage',
]

@Component({
  layout: 'mapViewV3',
  components: {
    Card,
    InfoCard,
    SideModalV3,
    Map,
    MapFilter,
    NotFound,
    MobileCard,
    MobileCardAmenity,
    MapPropertiesList,
    MapPropertiesPrintList,
  },
  computed: {
    ...mapState('ui', {
      isListingsVisible: 'isListingsVisible',
    }),
    ...mapState('consumer-map', {
      loadingHomes: 'loadingHomes',
      loadingHomeSites: 'loadingHomeSites',
      parentPageBaseURL: 'parentPageBaseURL',
      debouncedFilteredRequestExist: 'debouncedFilteredRequestExist',
      activeView: 'activeView',
    }),
    ...mapGetters('consumer-map', {
      isMapHiddenConsumerMapV3: 'isMapHiddenConsumerMapV3',
      isCondoFilteringEnabled: 'isCondoFilteringEnabled',
      reorderSidepanelPropertyTabs: 'reorderSidepanelPropertyTabs',
    }),
  },
  mixins: [globalStyling],
})
export default class ConsumerMap extends mixins(globalStyling) {
  project: PublicProject = null
  activeView: string
  amenity: any = null
  homes: LotInfo[] = []
  homeSites: LotInfo[] = []
  homesCount: number = 0
  homeSitesCount: number = 0
  models: Lot[] = null
  homeTabLabel: string = ''
  homesitesTabLabel: string = ''
  filterParams: any = null

  loadingHomeSites: boolean
  loadingHomes: boolean
  lotInformation: LotInfo = null

  homesNextPage: number = 1
  homeSitesNextPage: number = 1

  isMobile: boolean = false
  cardClicked: boolean = false
  hasLotInfoCardBeenClicked: boolean = false

  amenities: Amenity[] = []
  amenitiesData: Amenity[] = []

  poisCategories: Array<string> = []
  legacyAmenities: LegacyAmenity[] = []

  debouncedLoadMoreHomes: Function
  debouncedLoadMoreHomesHandler: Function

  @ProvideReactive() loSidebarHover: any = null
  summerSeason: boolean = true

  amenityCardSet: boolean = false
  selectedLot: any = ''

  lotsEdges: Array<string> = []
  activeTab: string = 'homes'

  isMapHiddenConsumerMapV3: boolean
  propertyCardClicked: boolean = false
  isCondoFilteringEnabled: boolean
  isListingsVisible: boolean
  reorderSidepanelPropertyTabs: boolean
  isPropertiesCountSet: boolean = false
  isSidePanelOpen: boolean = false

  seasonChange(value: boolean) {
    this.summerSeason = value
  }

  async created(): Promise<void> {
    try {
      await this.loadProjectsSpecificStyle(this.$route.params.slug)
      consumerMapStore.setParentPageBaseURL()
      if (!this.$route.query?.slug) {
        await this.setDefaultfilter()
      }
      // setting debounce request based on filter selection
      consumerMapStore.setDebouncedFilteredRequests(
        debounce(this.requestByFilters, 700)
      )

      await this.loadProject()
      await this.initConfig()
    } catch (exception: any) {
      this.$toast.error(exception.message as string)
    }
  }

  mounted() {
    this.$nuxt.$emit('sidePanelStateChange', this.isSidePanelOpen)
    this.setIsMobile()
    const activeViewModeFromUrl: string = this.$route.query.activeView as string
    if (activeViewModeFromUrl === 'map' || activeViewModeFromUrl === 'grid') {
      consumerMapStore.setActiveView(activeViewModeFromUrl)
    }
    if (this.isMapHiddenConsumerMapV3) consumerMapStore.setActiveView('grid')

    const element =
      window.innerWidth > 1024
        ? document.querySelector('#list-container-wrapper') // desktop view
        : document.querySelector('.mobile-view #list-container-wrapper') // mobile view

    // setting debounce request for load more home and homesites on scroll event in order to avoid repeated calls for the same page

    this.debouncedLoadMoreHomes = debounce(() => {
      if (element.classList.contains('homes')) {
        if (this.homesNextPage !== 0) {
          this.loadHomes()
            .then((homes) => {
              if (homes && homes.results.length) {
                this.homes = homes.results
              }
              consumerMapStore.setLoadingHomes(false)
            })
            .catch((error) => {
              this.$toast.error(error)
            })
        }
      } else if (element.classList.contains('homesites')) {
        if (this.homeSitesNextPage !== 0) {
          this.loadHomeSites()
            .then((homeSites) => {
              if (homeSites && homeSites.results.length) {
                this.homeSites = homeSites.results
              }
              consumerMapStore.setLoadingHomeSites(false)
            })
            .catch((error) => {
              this.$toast.error(error)
            })
        }
      }
    }, 1000)

    this.debouncedLoadMoreHomesHandler = setScrollOnBottomEvent(
      this.debouncedLoadMoreHomes,
      element
    )
  }

  beforeDestroy(): void {
    this.lotInformation = null
    removeScrollListener(
      document.querySelector('#list-container-wrapper'),
      this.debouncedLoadMoreHomesHandler
    )
    this.$nuxt.$off('salesMap:v3:seasonChanged')
    consumerMapStore.unsetDebouncedFilteredRequests()
  }

  async loadProjectsSpecificStyle(projectId: string) {
    await import(`assets/css/${projectId}.css`)
  }

  setDefaultfilter() {
    const key = this.getStyleVariableValue(
      '--ad-cm-default-filter-key'
    ).replace(/['"]+/g, '')

    const value = this.getStyleVariableValue(
      '--ad-cm-default-filter-value'
    ).replace(/['"]+/g, '')

    if (key && KNOWN_PARAMS.includes(key) && value) {
      const currentQuery = { ...this.$route.query }
      this.$router.push({
        path: this.$route.path,
        query: { [key]: value, ...currentQuery },
      })
    }
  }

  async initConfig(): Promise<void> {
    this.$nuxt.$on('salesMap:v3:seasonChanged', (value: boolean) => {
      this.seasonChange(value)
    })
    const projectSlug: string = this.$route.params.slug
    this.lotInformation = null

    this.homeTabLabel =
      projectConfig[projectSlug]?.homeTabLabel || 'Homes to Buy'
    this.homesitesTabLabel =
      projectConfig[projectSlug]?.homesitesTabLabel || 'Lots to Build'

    const queriesNames: Array<string> = Object.keys(this.$route.query)
    if (queriesNames.length <= 0 || !KNOWN_PARAMS.includes(queriesNames[0])) {
      await this.getLots()
    }

    if (queriesNames.includes('slug')) {
      let lot = this.getLotBySlug(this.$route.query.slug as string)
      let lotAdditionalPhotos = []
      if (!lot) {
        lot = await this.getLotInfoBySlug(this.$route.query.slug as string)
      }
      lotAdditionalPhotos = await this.getAdditionalPhotos(
        this.$route.query.slug as string
      )
      lot.additional_photos = lotAdditionalPhotos
      this.propertyCardClicked = true
      this.setLotInfo(lot)
    }

    if (this.$route?.query) {
      const params: any = this.$route?.query || {}
      consumerMapStore.setCustomQueryParams(params)
    }

    getModels(this.$route.params.slug)
      .then((response) => {
        this.models = response
      })
      .catch(() => {
        this.$toast.error(
          `Models load failed for ${this.$route.params.slug} project. Try again later.`
        )
        this.models = []
      })

    if (this.project.config.enable_poi_api) {
      try {
        this.poisCategories = await this.getPoisCategories()
        await this.loadAmenities({ firstLoad: true })
      } catch (error) {
        this.poisCategories = []
        this.$toast.error(`Amenities load failed. Try again later.`)
      }
    }
  }

  get lots(): Array<LotInfo> {
    return [...this.homes, ...this.homeSites]
  }

  async loadProject(): Promise<void> {
    try {
      const response = await getProject(this.$route.params.slug)
      if (window.innerWidth < 1024) {
        const activeViewUrl = this.$route.query.activeView
        if (!activeViewUrl) {
          consumerMapStore.setActiveView(
            response.config?.default_mobile_map_active_view || 'map'
          )
        }
      }
      this.project = response
      consumerMapStore.setCurrentProject(response)
      projectStore.setActiveProject({
        id: response.id,
        google_tag_manager_id: response.google_tag_manager_id || null,
      })
    } catch (exception) {
      throw new Error(
        `We are having trouble to load the ${this.$route.params.slug} project's data. Try again later.`
      )
    }
  }

  private resetPaginationHandling(): void {
    this.homesNextPage = 1
    this.homeSitesNextPage = 1
  }

  isCondoMasterPlan(): boolean {
    return this.isVisible('--ad-sp-condo-master-plan')
  }

  async getLots(): Promise<void> {
    let propertiesError

    try {
      const homes = await this.loadHomes({}, true)
      consumerMapStore.setTotalHomesFiltered(homes.count)
      this.homes = homes.results
      this.homesCount = homes.count
      consumerMapStore.setLoadingHomes(false)
    } catch (error: any) {
      consumerMapStore.setLoadingHomes(false)
      propertiesError = error
    }

    try {
      const homeSites = await this.loadHomeSites({}, true)
      consumerMapStore.setTotalHomeSitesFiltered(homeSites.count)
      this.homeSites = homeSites.results
      this.homeSitesCount = homeSites.count
      consumerMapStore.setLoadingHomeSites(false)
    } catch (error: any) {
      consumerMapStore.setLoadingHomeSites(false)
      propertiesError = error
    }

    consumerMapStore.setPropertiesCount(this.homesCount + this.homeSitesCount)
    this.isPropertiesCountSet = true
    this.getLotsForHighlight()

    if (propertiesError) {
      throw propertiesError
    }
  }

  private async loadHomes(
    params: any = {},
    newRequest: boolean = false
  ): Promise<PagedResponse<LotInfo>> {
    consumerMapStore.setLoadingHomes(true)

    if (!newRequest && this.homesNextPage === 1) {
      this.homesNextPage++
    }

    const projectSlug: string = this.$route.params.slug
    try {
      if (this.homesNextPage > 0) {
        const queryParams =
          Object.keys(params).length !== 0 ? params : this.filterParams || {}
        const response = await getConsumerMapHomes(
          projectSlug,
          this.isCondoMasterPlan(),
          {
            ...queryParams,
            page: !newRequest ? this.homesNextPage : 1,
          }
        )

        const homes =
          this.homesNextPage === 1
            ? [...response.results]
            : [...this.homes, ...response.results]

        if (response.next) {
          !newRequest ? this.homesNextPage++ : (this.homesNextPage = 1)
        } else this.homesNextPage = 0

        return {
          results: homes,
          count: response.count,
          next: response.next,
          previous: response.previous,
        }
      }
    } catch (exception) {
      if (exception) {
        console.log(`Error: ${exception}`)
        throw new Error(
          `We are having trouble to load ${this.$route.params.slug} homes. Try again later.`
        )
      }
    }
  }

  private async loadHomeSites(
    params: any = {},
    newRequest: boolean = false
  ): Promise<PagedResponse<LotInfo>> {
    consumerMapStore.setLoadingHomeSites(true)

    if (!newRequest && this.homeSitesNextPage === 1) {
      this.homeSitesNextPage++
    }
    const projectSlug: string = this.$route.params.slug
    try {
      if (this.homeSitesNextPage > 0) {
        const queryParams =
          Object.keys(params).length !== 0 ? params : this.filterParams || {}
        const response = await getConsumerMapHomesites(
          projectSlug,
          this.isCondoMasterPlan(),
          {
            ...queryParams,
            page: !newRequest ? this.homeSitesNextPage : 1,
          }
        )

        const homeSites =
          this.homeSitesNextPage === 1
            ? [...response.results]
            : [...this.homeSites, ...response.results]

        if (response.next) {
          !newRequest ? this.homeSitesNextPage++ : (this.homeSitesNextPage = 1)
        } else this.homeSitesNextPage = 0

        return {
          results: homeSites,
          count: response.count,
          next: response.next,
          previous: response.previous,
        }
      }
    } catch (exception) {
      if (exception) {
        console.log(`Error: ${exception}`)
        throw new Error(
          `We are having trouble to load ${this.$route.params.slug} homesites. Try again later.`
        )
      }
    }
  }

  private async requestByFilters(filters: any[]) {
    if (this.$route.name !== 'v3-map-slug') {
      return
    }
    this.homes = []
    this.homeSites = []
    this.resetPaginationHandling()
    const query: {
      builder?: string
      beds?: string
      baths?: string
      style?: string
      stories?: string
      garages?: string
      neighborhood?: string
      sqft_min?: string
      sqft_max?: string
      price_min?: string
      price_max?: string
      move_in_date?: string
      sort?: string
      condo_at?: string
      property_type?: string
      acreage?: string
    } = {}
    const params: any = {}
    filters.forEach((filter) => {
      if (filter.type === 'bedrooms') {
        params.beds = filter.value
        query.builder = params.builder
      } else if (filter.type === 'baths') {
        params.baths = filter.value
        query.baths = params.baths
      } else if (filter.type === 'stories') {
        params.stories = filter.value
        query.stories = params.stories
      } else if (filter.type === 'garages') {
        params.garages = filter.value
        query.garages = params.garages
      } else if (filter.type === 'sqft_min') {
        params.sqft_min = filter.value
        query.sqft_min = params.sqft_min
      } else if (filter.type === 'sqft_max') {
        params.sqft_max = filter.value
        query.sqft_max = params.sqft_max
      } else if (filter.type === 'price_min') {
        params.price_min = filter.value
        query.price_min = params.price_min
      } else if (filter.type === 'price_max') {
        params.price_max = filter.value
        query.price_max = params.price_max
      } else if (filter.type === 'move_in_date') {
        params.move_in_date = filter.value
        query.move_in_date = params.move_in_date
      } else if (filter.type === 'builder') {
        if (!params.builder) params.builder = [filter.value]
        else params.builder.push(filter.value)
        query.builder = params.builder
      } else if (filter.type === 'arch') {
        if (!params.style) params.style = [filter.value]
        else params.style.push(filter.value)
        query.style = params.style
      } else if (filter.type === 'neighborhood') {
        if (!params.neighborhood) params.neighborhood = [filter.value]
        else params.neighborhood.push(filter.value)
        query.neighborhood = params.neighborhood
      } else if (filter.classification === 'custom') {
        if (!params[filter.type]) params[filter.type] = [filter.value]
        else params[filter.type].push(filter.value)
        query[filter.type] = params[filter.type]
      } else if (filter.type === 'sort') {
        params.sort = filter.value
        query.sort = params.sort
      } else if (filter.type === 'condo_at') {
        if (!params.condo_at) params.condo_at = [filter.value]
        else params.condo_at.push(filter.value)
        query.condo_at = params.condo_at
      } else if (filter.type === 'property_type') {
        if (!params.property_type) params.property_type = [filter.value]
        else params.property_type.push(filter.value)
        query.property_type = params.property_type
      } else if (filter?.type === 'acreage') {
        if (!params.acreage) {
          params.acreage = [filter.value.split(',').map((val: string) => val)]
        } else {
          params.acreage.push(filter.value.split(',').map((val: string) => val))
        }
        query.acreage = params.acreage
      }
    })
    this.filterParams = params

    try {
      const homes = await this.loadHomes(params, true)
      if (homes) {
        consumerMapStore.setTotalHomesFiltered(homes.count)
        this.homes = homes.results
        this.homesCount = homes.count
        consumerMapStore.setLoadingHomes(false)
      }

      const homesites = await this.loadHomeSites(params, true)
      if (homesites) {
        consumerMapStore.setTotalHomeSitesFiltered(homesites.count)
        this.homeSites = homesites.results
        this.homeSitesCount = homesites.count
        consumerMapStore.setLoadingHomeSites(false)
      }

      this.$router.push({
        path: this.$route.path,
        query,
      })

      const mapPropertiesList = this.$refs.MapPropertiesList as Vue & {
        toggleTab: (index: string) => void
      }

      if (
        mapPropertiesList &&
        typeof mapPropertiesList?.toggleTab === 'function'
      ) {
        if (this.reorderSidepanelPropertyTabs && homesites?.count) {
          mapPropertiesList.toggleTab(MapSidebarTabs.HOMESITES)
        } else if (homes?.count) {
          mapPropertiesList.toggleTab(MapSidebarTabs.HOMES)
        } else if (homesites?.count) {
          mapPropertiesList.toggleTab(MapSidebarTabs.HOMESITES)
        }
      }

      if (!this.isPropertiesCountSet) {
        consumerMapStore.setPropertiesCount(
          this.homesCount + this.homeSitesCount
        )
        this.isPropertiesCountSet = true
      }
    } catch (error) {
      this.$toast.error(error)
    }
  }

  async setLotInfo(lotInfo: LotInfo): Promise<void> {
    this.hasLotInfoCardBeenClicked = true
    this.setIsMobile()
    if (lotInfo) {
      try {
        let lotAdditionalPhotos = []
        lotAdditionalPhotos = await this.getAdditionalPhotos(
          lotInfo?.slug as string
        )
        lotInfo.additional_photos = lotAdditionalPhotos
      } catch (error) {
        lotInfo.additional_photos = []
        this.$toast.error(
          `Additional photos load failed for ${
            lotInfo?.slug as string
          }. Try again later.`
        )
      }
      if (!this.isMobile) {
        if (
          this.isCondoFilteringEnabled &&
          lotInfo.property_type === 'Condo' &&
          !this.propertyCardClicked
        ) {
          this.$nuxt.$emit('CondoClicked', lotInfo)
        }
      }
    }

    this.lotInformation = lotInfo
    this.selectedLot = lotInfo
    this.isSidePanelOpen = true
    this.$nuxt.$emit('sidePanelStateChange', this.isSidePanelOpen)
    if (!lotInfo) {
      this.loSidebarHover = null
      return
    }

    this.loSidebarHover = {
      centerpoint: lotInfo.centerpoint,
      parcel_id: lotInfo.parcel_id,
    }
  }

  closeSideModalV3() {
    this.setLotInfo(null)
    this.cardClicked = false
    this.propertyCardClicked = false
    this.isSidePanelOpen = false
    this.$nuxt.$emit('sidePanelStateChange', this.isSidePanelOpen)
  }

  removeLotInfo() {
    if (!this.hasLotInfoCardBeenClicked && !this.cardClicked) {
      this.setLotInfo(null)
      this.hasLotInfoCardBeenClicked = true
    } else {
      this.hasLotInfoCardBeenClicked = false
    }
  }

  setIsMobile() {
    if (window.innerWidth < 1024) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  }

  mobilecardClick(): void {
    this.cardClicked = true
    if (
      this.isCondoFilteringEnabled &&
      this.lotInformation.property_type === 'Condo' &&
      !this.propertyCardClicked
    ) {
      this.$nuxt.$emit('CondoClicked', this.lotInformation, () => {
        consumerMapStore.setActiveView('grid')
      })
    }
  }

  // this will help to highlight the lot iether user hover over the lot card or clicks and open the side modal
  onLotListHover(lotInfo: any): void {
    if (!lotInfo && !this.lotInformation) return (this.loSidebarHover = null)
    const lot = {
      centerpoint: lotInfo
        ? lotInfo.centerpoint
        : this.lotInformation
        ? this.lotInformation.centerpoint
        : null,
      parcel_id: lotInfo
        ? lotInfo.parcel_id
        : this.lotInformation
        ? this.lotInformation.parcel_id
        : null,
      is_condo: lotInfo
        ? lotInfo.property_type === 'Condo'
        : this.lotInformation
        ? this.lotInformation.property_type === 'Condo'
        : false,
    }
    this.loSidebarHover = {
      centerpoint: lot.centerpoint,
      parcel_id: lot.parcel_id,
      isCondo: lot.is_condo,
    }
  }

  async getPoisCategories(): Promise<Array<string>> {
    try {
      const poisCategories: CategoryResponse = await getPoiCategories({
        slug: this.$route.params.slug,
      })
      const categories = poisCategories.items
      return [...new Set(categories.map((category) => category.name))]
    } catch (error) {
      return []
    }
  }

  async performSearch(data: any): Promise<void> {
    try {
      await this.loadAmenities(data)
    } catch (exception) {
      console.log(exception)
    }
  }

  async loadAmenities({
    searchText = '',
    category = '',
    firstLoad = false,
  }: {
    searchText?: string
    category?: string
    firstLoad?: boolean
  } = {}): Promise<void> {
    try {
      if (this.project.config.enable_poi_api) {
        if (!searchText && !category && !firstLoad) {
          this.amenitiesData = []
          return
        }
        const pois: AmenityResponse = await getAllAmenities({
          slug: this.$route.params.slug,
          search: searchText,
          category,
        })
        if (this.isVisible('--v3-cm-sort-pois-alpha-numeric')) {
          pois.items.sort((a, b) => a.name.localeCompare(b.name))
        }
        if (firstLoad) {
          this.amenities = this.amenitiesData = pois.items
        } else {
          this.amenitiesData = pois.items
        }
      } else {
        try {
          const oldPois = await getLegacyXOAmenities()
          this.legacyAmenities = oldPois.map((poi) => ({
            ...poi,
            legacy: true,
          }))
        } catch (error) {
          this.$toast.error(`Amenities load failed. Try again later.`)
        }
      }
    } catch (exception) {
      this.amenitiesData = []
      this.amenities = []
      this.legacyAmenities = []
      console.log(exception)
    }
  }

  setAmenity(amenity: Object) {
    this.setIsMobile()
    this.amenity = amenity
    this.amenityCardSet = true
  }

  removeAmenity() {
    if (this.amenity && !this.amenityCardSet) {
      this.amenity = null
    }
    this.amenityCardSet = false
  }

  getLotBySlug(slug: string): LotInfo {
    const lots = [...this.homes, ...this.homeSites]

    return lots.find((lot) => lot.slug === slug)
  }

  async getAdditionalPhotos(lotSlug: string): Promise<any> {
    try {
      const additionalPhotos = await getLotAditionalPhotos(lotSlug)
      return additionalPhotos
    } catch (error) {
      return []
    }
  }

  async getLotInfoBySlug(lotSlug: string): Promise<any> {
    try {
      const property = await getConsumerMapProperty(
        this.$route.params.slug,
        lotSlug
      )
      return property
    } catch (error) {
      return null
    }
  }

  updateActiveViewFromUrl(value: 'grid' | 'map') {
    consumerMapStore.setActiveView(value)
  }

  async getLotsForHighlight(): Promise<void> {
    if (!this.isEdgeHighlightEnabled) {
      return
    }

    const type =
      this.activeTab === MapSidebarTabs.HOMES
        ? LotTypes.HOME
        : LotTypes.HOME_SITE.replace(' ', '')

    const response: any = await getParcelIdsByType(
      type,
      this.project.slug,
      this.filterParams
    )

    this.lotsEdges = response.data || []
  }

  get isEdgeHighlightEnabled(): boolean {
    if (!this.project || !this.project.config) {
      return false
    }
    return this.project.config.enable_highlight_edges
  }

  handleTabChanged(tab: MapSidebarTabs): void {
    if (!this.isMobile) {
      this.onTabChanged(tab)
    }
  }

  shouldExtendListing(): boolean {
    if (this.activeView === 'grid' || this.isMapHiddenConsumerMapV3) {
      return true
    }
  }

  onTileViewChanged(): void {
    consumerMapStore.toggleActiveView(this.activeView as 'map' | 'grid')
  }

  onTabChanged(tab: MapSidebarTabs): void {
    this.activeTab = tab
    this.getLotsForHighlight()
  }

  updatePropertyCardClicked(value: boolean): void {
    this.propertyCardClicked = value
  }

  showSideModal() {
    if (
      !this.propertyCardClicked &&
      this.isCondoFilteringEnabled &&
      this.lotInformation?.property_type === 'Condo'
    ) {
      return false
    }
    return true
  }

  toggleListingsVisibility() {
    uiStore.setIsListingsVisible(!this.isListingsVisible)
    this.$nextTick(() => {
      this.$nuxt.$emit('resizeMap')
    })
  }
}
